export default __webpack_public_path__ + "static/media/ZEPHYR.ee2079cf.svg";